
import { Vue, Options } from "vue-class-component";
import { CargoV2Controller } from "@/app/ui/controllers/CargoV2Controller";
import { FormCargoV2 } from "@/domain/entities/CargoV2";

@Options({})
class CargoV2CreateIndex extends Vue {  
  tabs = [
    {
      path: "plane",
      titleKey: "cargoV2.create.index.tab.plane"
    },
    {
      path: "truck",
      titleKey: "cargoV2.create.index.tab.truck"
    },
    {
      path: "ship",
      titleKey: "cargoV2.create.index.tab.ship"
    }
  ];

  mounted() {
    CargoV2Controller.resetForm();
    CargoV2Controller.setUploadProofPhoto(false);
  }

  unmounted() {
    CargoV2Controller.setIsFirstLandingRtc(true);
  }

  onTabClick(tab: { path: string; titleKey: string }, navigate: () => void) {
    CargoV2Controller.setIsFirstLandingRtc(false);
    navigate();
  }

  onCreateBookingManual() {
    CargoV2Controller.resetForm();
    CargoV2Controller.setUploadProofPhoto(false);
    this.$nextTick().then(() => {
      this.$router.push('/cargo-v2/create/manual')
    })
  }
}
export default CargoV2CreateIndex;
